



















































































































































































































































































































































































import Vue from "vue";

// Components
import VFaIcon from "@/components/VFaIcon.vue";

// Model
import { Configuration, DelayConfiguration } from "@/model/data/security/Configuration";
import { DelayTypeEnum } from "@/model/data/enums/DelayTypeEnum";
import { formatSeconds } from "@/utility/Formatter";
import { mapGetters } from "vuex";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: { VFaIcon },
    props: {
        installationName: String,
        configuration: { type: Object as () => Configuration, required: true },
        editMode: Boolean,
        loading: Boolean,
    },
    data() {
        return {
            DelayTypeEnum,
            reservationsTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            emptyOutTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            limitationsTableHeader: [
                { text: this.$t("security_management.delayAmount"), value: "amount", align: "center", sortable: false },
                { text: this.$t("security_management.delayTime"), value: "delay", align: "center", sortable: false },
            ],
            reservationTemp: [],
            onlyIntegerValidator: [(v) => /^\d+$/.test(v) || this.$t("security_management.onlyInteger")],
            reservationPermanenceTemp: 0,
            emptyOutTemp: {
                options: 0,
                delay: 0,
                amount: 0,
            },
            emptyOutOptionTemp: 0,
            limitationTemp: {
                amount: 0,
                delay: 0,
            },
            localConfiguration: null,
        };
    },
    watch: {
        configuration: {
            handler(newValue: Configuration) {
                this.resetConfiguration(newValue);
            },
            immediate: true,
        },
        editMode: {
            handler(newVal) {
                if (newVal) this.enterEditMode();
            },
            immediate: true,
        },
        canSave: {
            handler(newVal) {
                this.$emit("can-save", newVal, "delays");
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        canWriteDelays() {
            return this.authUserHasPrivilege(ClientPrivileges.WriteDelays);
        },

        canSave() {
            if (this.reservationTemp) {
                for (let i = 0; i < this.reservationTemp.length; i++) {
                    if (!/^\d+$/.test(this.reservationTemp[i].delay) || !/^\d+$/.test(this.reservationTemp[i].amount)) return false;
                    if (this.reservationTemp[i].amount < 1) return false;

                    if (i > 0 && this.reservationTemp[i - 1].amount >= this.reservationTemp[i].amount) return false;
                    if (i + 1 < this.reservationTemp.length && this.reservationTemp[i + 1].amount <= this.reservationTemp[i].amount) return false;
                }
            }

            if (!/^\d+$/.test(this.reservationPermanenceTemp)) return false;
            if (this.emptyOutOptionTemp == 0 && (!/^\d+$/.test(this.emptyOutTemp.amount) || !/^\d+$/.test(this.emptyOutTemp.delay))) return false;
            if (!/^\d+$/.test(this.limitationTemp.amount) || !/^\d+$/.test(this.limitationTemp.delay)) return false;
            return true;
        },
        reservations: {
            get() {
                let reservations = [];
                if (this.configuration && this.configuration.delays) {
                    reservations = this.configuration.delays
                        .filter((d) => d.type == DelayTypeEnum.Reservation && d.amount != 0)
                        .sort(function (a, b) {
                            return a.amount - b.amount;
                        });
                }
                return reservations;
            },
            set(newValue: Array<DelayConfiguration>) {
                if (this.localConfiguration && this.localConfiguration.delays) {
                    let reservations = this.localConfiguration.delays
                        .filter((d) => d.type == DelayTypeEnum.Reservation)
                        .sort(function (a, b) {
                            return a.amount - b.amount;
                        });
                    if (reservations) {
                        this.localConfiguration.delays = this.localConfiguration.delays.filter((d) => d.type != DelayTypeEnum.Reservation);
                    }
                }

                for (let i = 0; i < newValue.length; i++) {
                    let d = new DelayConfiguration();
                    d.amount = newValue[i].amount;
                    d.delay = newValue[i].delay;
                    d.type = DelayTypeEnum.Reservation;
                    d.options = newValue[i].options;
                    this.localConfiguration.delays.push(d);
                }
            },
        },
        permanence: {
            get() {
                let permanence = 0;
                if (this.configuration && this.configuration.delays) {
                    let p = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Permanence && d.delay != 0);
                    if (p && p.length) {
                        permanence = p[0].delay;
                    }
                }
                return permanence;
            },
            set(newValue: number) {
                let existingPermanence = this.localConfiguration.delays.filter((d) => d.type == DelayTypeEnum.Permanence);
                if (existingPermanence && existingPermanence.length == 1) {
                    existingPermanence[0].delay = newValue;
                } else {
                    let d = new DelayConfiguration();
                    d.delay = newValue;
                    d.type = DelayTypeEnum.Permanence;
                    d.amount = 0;
                    this.localConfiguration.delays.push(d);
                }
            },
        },
        emptyOut: {
            get() {
                if (this.configuration && this.configuration.delays) {
                    let emptyOut = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Emptyout);
                    return emptyOut[0];
                }
                return null;
            },
            set(newValue: { delay: number; amount: number; options: number }) {
                let existingEmptyOut = this.localConfiguration.delays.filter((d) => d.type == DelayTypeEnum.Emptyout);
                if (existingEmptyOut && existingEmptyOut.length) {
                    existingEmptyOut[0].delay = newValue.delay;
                    existingEmptyOut[0].amount = newValue.amount;
                    existingEmptyOut[0].options = newValue.options;
                } else {
                    let d = new DelayConfiguration();
                    d.delay = newValue.delay;
                    d.amount = newValue.amount;
                    d.options = newValue.options;
                    d.type = DelayTypeEnum.Emptyout;
                    this.localConfiguration.delays.push(d);
                }
            },
        },
        limitations: {
            get() {
                let limitations = [];
                if (this.configuration && this.configuration.delays) {
                    limitations = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Limitation && d.amount != 0);
                }
                return limitations[0];
            },
            set(newValue: { delay: number; amount: number }) {
                let existingLimitation = this.localConfiguration.delays.filter((d) => d.type == DelayTypeEnum.Limitation);
                if (existingLimitation && existingLimitation.length) {
                    existingLimitation[0].delay = newValue.delay;
                    existingLimitation[0].amount = newValue.amount;
                } else {
                    if (newValue.delay > 0 && newValue.amount > 0) {
                        let d = new DelayConfiguration();
                        d.delay = newValue.delay;
                        d.amount = newValue.amount;
                        d.type = DelayTypeEnum.Limitation;
                        this.localConfiguration.delays.push(d);
                    }
                }
            },
        },
        inputLimitations() {
            let limitations = [];
            if (this.configuration && this.configuration.delays) {
                limitations = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.InputLimit && d.amount != 0);
            }
            return limitations;
        },
        emptyOutOption: {
            get() {
                let emptyOutOption = 0;
                if (this.configuration && this.configuration.delays) {
                    let p = this.configuration.delays.filter((d) => d.type == DelayTypeEnum.Permanence);
                    if (p && p.length) {
                        emptyOutOption = p[0].options;
                    }
                }
                return emptyOutOption;
            },
            set(newValue: number) {
                let existingEmptyOutOption = this.localConfiguration.delays.filter((d) => d.type == DelayTypeEnum.Permanence);
                if (existingEmptyOutOption && existingEmptyOutOption.length) {
                    existingEmptyOutOption[0].options = newValue;
                } else {
                    let d = new DelayConfiguration();
                    d.options = newValue;
                    d.delay = 0;
                    d.amount = 0;
                    d.type = DelayTypeEnum.Permanence;
                    this.localConfiguration.delays.push(d);
                }
            },
        },
    },
    methods: {
        formatSeconds,
        resetConfiguration(configuration: Configuration) {
            this.localConfiguration = new Configuration();
            if (configuration) this.localConfiguration.clone(configuration);
        },
        getDelayAmountLowerBound(amount: number) {
            for (let i = 0; i < this.reservations.length; i++) {
                if (this.reservations[i].amount == amount) {
                    if (i == 0) return `0 - ${amount}`;
                    else return `${this.reservations[i - 1].amount + 1} - ${amount}`;
                }
            }
        },
        getDelayAmountLowerBoundLive(index: number) {
            if (index == 0) return "0";
            else return `${this.reservationTemp[index - 1].amount + 1}`;
        },
        saveConfiguration() {
            if (!this.localConfiguration) this.localConfiguration = new Configuration();
            if (!this.localConfiguration.delays) this.localConfiguration.delays = new Array<DelayConfiguration>();
            this.reservations = this.reservationTemp;
            this.permanence = this.reservationPermanenceTemp;
            this.emptyOutOption = this.emptyOutOptionTemp;
            this.emptyOut = this.emptyOutTemp;
            this.limitations = this.limitationTemp;

            return this.localConfiguration;
        },
        enterEditMode() {
            this.reservationTemp = this.reservations.map(({ amount, delay, options }) => ({
                amount,
                delay,
                options,
            }));
            this.reservationPermanenceTemp = this.permanence;
            this.emptyOutOptionTemp = this.emptyOutOption;
            this.emptyOutTemp.delay = this.emptyOut && this.emptyOut.delay ? this.emptyOut.delay : 0;
            this.emptyOutTemp.amount = this.emptyOut && this.emptyOut.amount ? this.emptyOut.amount : 0;
            this.emptyOutTemp.options = this.emptyOut && this.emptyOut.options ? this.emptyOut.options : 0;

            this.limitationTemp.amount = this.limitations && this.limitations.amount ? this.limitations.amount : 0;
            this.limitationTemp.delay = this.limitations && this.limitations.delay ? this.limitations.delay : 0;
            this.$emit("enter-edit-mode");
        },
        deleteWithdrawalDelay(index: number) {
            this.reservationTemp.splice(index, 1);
        },
        addWithdrawalDelay() {
            this.reservationTemp.push({ amount: null, delay: null, options: 0 });
        },
    },
});
